"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFundingFeeRecord = void 0;
const RecordApi_1 = require("../../apis/RecordApi");
const usePullRefresh_1 = require("../../hooks/usePullRefresh");
const operators_1 = require("rxjs/operators");
const FundingFeeRecordPageLength = 10;
/**查询资金费记录 */
function useFundingFeeRecord(props) {
    const { filterParams, accountType, limit = FundingFeeRecordPageLength } = props;
    return (0, usePullRefresh_1.usePullRefreshV2)({
        query: (params) => {
            return (0, RecordApi_1.queryFundingFeeRecord)(Object.assign(Object.assign(Object.assign({ accountType }, params), { limit }), filterParams)).pipe((0, operators_1.map)((resp) => {
                const page_cursor = !(resp === null || resp === void 0 ? void 0 : resp.next_page_cursor) || (resp === null || resp === void 0 ? void 0 : resp.next_page_cursor) === "0" ? undefined : resp === null || resp === void 0 ? void 0 : resp.next_page_cursor;
                return {
                    data: (resp === null || resp === void 0 ? void 0 : resp.fundings) || [],
                    hasMore: !!page_cursor,
                    params: {
                        page_cursor,
                    },
                };
            }));
        },
    });
}
exports.useFundingFeeRecord = useFundingFeeRecord;
